import Api from '~/config/Api'
const endpoint = Api.sportCategories

export default {
  async fetch () {
    const { data } = await useApi(endpoint)

    return data
  }
}
